import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { ListProductsComponent } from './components/inventory/list-products/list-products.component';
import { CreateProductsComponent } from './components/inventory/create-products/create-products.component';
import { CustomerListComponent } from './components/masters/customer/customer-list/customer-list.component';
import { NewCustomerComponent } from './components/masters/customer/new-customer/new-customer.component';
import { CustomerDetailsComponent } from './components/masters/customer/customer-details/customer-details.component';
import { VendorListComponent } from './components/masters/vendors/vendor-list/vendor-list.component';
import { NewVendorComponent } from './components/masters/vendors/new-vendor/new-vendor.component';
import { SalesPersonListComponent } from './components/masters/sales-person/sales-person-list/sales-person-list.component';
import { NewSalesPersonComponent } from './components/masters/sales-person/new-sales-person/new-sales-person.component';
import { CreateBOMComponent } from './components/inventory/Bill-Of-Material/create-bom/create-bom.component';
import { CreateQuoteComponent } from './components/Sales/Quote/create-quote/create-quote.component';
import { ListQuoteComponent } from './components/Sales/Quote/list-quote/list-quote.component';
import { ListPurchaseorderComponent } from './components/Purchase/purchaseorder/list-purchaseorder/list-purchaseorder.component';
import { CreatePurchaseorderComponent } from './components/Purchase/purchaseorder/create-purchaseorder/create-purchaseorder.component';
import { CreateOrderComponent } from './components/Sales/Order/create-order/create-order.component';
import { OrderListComponent } from './components/Sales/Order/order-list/order-list.component';
import { AccountListComponent } from './components/accounts/account-list/account-list.component';
import { CreateAccountsComponent } from './components/accounts/create-accounts/create-accounts.component';
import { GstListComponent } from './components/administration/GST/gst-list/gst-list.component';
import { CreateMenuComponent } from './components/administration/Menu/create-menu/create-menu.component';
import { MenuListComponent } from './components/administration/Menu/menu-list/menu-list.component';
import { CreateUnitOfMeasureComponent } from './components/administration/Units/create-unit-of-measure/create-unit-of-measure.component';
import { ListUnitOfMeasureComponent } from './components/administration/Units/list-unit-of-measure/list-unit-of-measure.component';
import { AssignRoleComponent } from './components/administration/assign-role/assign-role.component';
import { CreateRolesComponent } from './components/administration/create-roles/create-roles.component';
import { CreatePaymentTermsComponent } from './components/administration/payment-terms/create-payment-terms/create-payment-terms.component';
import { ListPaymentTermsComponent } from './components/administration/payment-terms/list-payment-terms/list-payment-terms.component';
import { RoleListComponent } from './components/administration/role-list/role-list.component';
import { UserListComponent } from './components/administration/user-list/user-list.component';
import { UserRegistrationComponent } from './components/Administration/user-registration/user-registration.component';
import { ListWarehouseComponent } from './components/administration/warehouse/list-warehouse/list-warehouse.component';
import { NewWarehouseComponent } from './components/administration/warehouse/new-warehouse/new-warehouse.component';
import { CreateInvoiceComponent } from './components/Sales/Invoice/create-invoice/create-invoice.component';
import { InvoiceListComponent } from './components/Sales/Invoice/invoice-list/invoice-list.component';
import { DispatchSalesOrderComponent } from './components/Sales/Shipping/dispatch-sales-order/dispatch-sales-order.component';
import { ViewDispatchSalesOrderComponent } from './components/Sales/Shipping/view-dispatch-sales-order/view-dispatch-sales-order.component';
import { ReceivePurchaseorderComponent } from './components/Purchase/Recive PO/receive-purchaseorder/receive-purchaseorder.component';
import { ReceivePurchaseorderListComponent } from './components/Purchase/Recive PO/receive-purchaseorder-list/receive-purchaseorder-list.component';
import { CreateMOComponent } from './components/Purchase/manufacture/create-manufacturing-orders/create-manufacturingorders.component';
import { ListManufacturingOrdersComponent } from './components/Purchase/manufacture/list-manufacturing-orders/list-manufacturing-orders.component';
import { ReportListComponent } from './components/Reports/report-list/report-list.component';
import { DashboardComponent } from './components/dashboard_/dashboard.component';
import { SalesdashboardComponent } from './components/Dashboard/sales-dashboard/salesdashboard.component';
import { CreateProjectComponent } from './components/masters/project-management/create-project/create-project.component';
import { ListProjectComponent } from './components/masters/project-management/list-project/list-project.component';
import { ListBOMComponent } from './components/inventory/Bill-Of-Material/list-bom/list-bom.component';
import { CreateReceiptsComponent } from './components/Receipts/create-receipts/create-receipts.component';
import { ReceiptsListComponent } from './components/Receipts/receipts-list/receipts-list.component';
import { CreateProductCategoryComponent } from './components/Administration/Prodcut Category/create-product-category/create-product-category.component';
import { ProductCategoryListComponent } from './components/Administration/Prodcut Category/product-category-list/product-category-list.component';

import { CreateProductGroupComponent } from './components/Administration/Prodcut Category/create-product-group/create-product-group.component';

import { HomeDashboardComponent } from './components/Dashboard/home-dashboard/home-dashboard.component';
import { CompanyInfoListComponent } from './components/Administration/company-information/company-information-list/company-info-list.component';
import { NewCompanyInfoComponent } from './components/Administration/company-information/new-company-information/new-company.component';
import { InventoryDashboardComponent } from './components/Dashboard/inventory-dashboard/inventory-dashboard.component';
import { WarehouseDashboardComponent } from './components/Dashboard/warehouse-dashboard/warehouse-dashboard.component';
import { SessionExpiredComponent } from './components/session-expired/session-expired.component';
import { BackOrderListComponent } from './components/Sales/Back Order/back-order-list/back-order-list.component';
import { ForceOrderProcessComponent } from './components/Sales/Back Order/force-order-process/force-order-process.component';
import { CreatebankComponent } from './components/Accounts/Bank/create-bank/create-bank.component';
import { BankListComponent } from './components/Accounts/Bank/bank-list/bank-list.component';
import { CreateDeliveryChallanComponent } from './components/inventory/DeliveryChallan/create-delivery-challan/create-delivery-challan.component';
import { DeliveryChallanListComponent } from './components/inventory/DeliveryChallan/delivery-challan-list/delivery-challan-list.component';
import { CreatePaymentReceiptsComponent } from './components/Accounts/create-payment-receipts/create-payment-receipts.component';
import { AssignRoleListComponent } from './components/Administration/Assign-Role-List/assign-role-list.component';
import { PaymentReceiptListComponent } from './components/Accounts/payment-receipt-list/payment-receipt-list.component';
import { CreateDealComponent } from './components/CRM/Deal/create-deal/create-deal.component';
import { ListDealComponent } from './components/CRM/Deal/list-deal/list-deal.component';
import { ListTaskComponent } from './components/CRM/Task/list-task/list-task.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { MenuGuard } from './guards/menu.guard';
import { CreateReturnPurchaseorderComponent } from './components/Purchase/Return PO/create-returnpurchaseorder/create-returnpurchaseorder.component';
import { ListReturnPurchaseorderComponent } from './components/Purchase/Return PO/list-returnpurchaseorder/list-returnpurchaseorder.component';
import { CRMContactComponentComponent } from './components/CRM/Contact/crmcontact-component/crmcontact-component.component';
import { ListCRMContactComponentComponent } from './components/CRM/Contact/list-crmcontact-component/list-crmcontact-component.component';
import { ListRFQComponent } from './components/RFQ/list-rfq/list-rfq.component';
import { CreateRFQComponent } from './components/RFQ/create-rfq/create-rfq.component';
import { CreateStoreConsumptionsComponent } from './components/inventory/create-store-consumptions/create-store-consumptions.component';
import { ListStoreConsumptionsComponent } from './components/inventory/list-store-consumptions/list-store-consumptions.component';
import { HRMSHomeDashboardComponent } from './components/HRMS/home-hrmsdashboard/home-hrmsdashboard.component';
import { ListShiftComponent } from './components/HRMS/shift-management/list-shift/list-shiftcomponentcomponent';
import { CreateShiftComponent } from './components/HRMS/shift-management/create-shift/create-shift-componentcomponent';
import { EmployeeComponent } from './components/HRMS/employee-management/create-employee-component/employee-componentcomponent';
import { ListEmployeeComponent } from './components/HRMS/employee-management/list-employee-component/list-employee-componentcomponent';
import { OperationComponent } from './components/HRMS/operation-component/operation-component.component';
import { CalendarComponent } from './components/HRMS/calendar/calendar.component';
import { AccountingDashboardComponent } from './components/Dashboard/accounting-dashboard/accounting-dashboard.component';
import { AttendanceApprovalComponent } from './components/HRMS/attendance/attendance-approval/create-attendance-approval.component';
import { OnboardingListComponent } from './components/HRMS/onboard/onboarding-list/onboarding-list.component';
import { AddEmployeeComponent } from './components/HRMS/onboard/add-employee/add-employee.component';
import { ExpenseComponent } from './components/HRMS/expense/create-expense/create-expense.component';
import { ListExpenseComponent } from './components/HRMS/expense/list-expense/list-expense.component';
import { AllfeedComponent } from './components/HRMS/emp-engagement/allfeed/allfeed.component';
import { AlllistComponent } from './components/HRMS/emp-engagement/alllist/alllist.component';
// import { FilestabComponent } from './components/HRMS/files/filestab/filestab.component';
// import { FileslistComponent } from './components/HRMS/files/fileslist/fileslist.component';
// import { CreateTaskComponent } from './components/CRM/Task/create-task/create-task.component';



export const routes: Routes = [
    {
        path: '',
        component: LoginComponent
    },

    {
        path: 'session',
        component: SessionExpiredComponent
    },

    {
        path: 'unauthorized',
        component: UnauthorizedComponent
    },

    {
        path: 'home',
        component: HomeComponent,
        children: [
            {
                path: 'dashboard',
                component: HomeDashboardComponent
            },
            {
                path: 'AccountingDashboard',
                component: AccountingDashboardComponent
            },
            {
                path: 'listProducts',
                component: ListProductsComponent,
                // canActivate: [MenuGuard],
                // data: { menuName: 'listProducts' }
            },
            {
                path: 'inventory',
                component: ListProductsComponent
            },
            {
                path: 'createProducts',
                component: CreateProductsComponent,
                // canActivate: [MenuGuard],
                // data: { menuName: 'createProducts' }
            },
            {
                path: 'listCustomers',
                component: CustomerListComponent
            },
            {
                path: 'createCustomers',
                component: NewCustomerComponent
            },
            {
                path: 'customerDetails',
                component: CustomerDetailsComponent
            },
            {
                path: 'listvendors',
                component: VendorListComponent
            },
            {
                path: 'createvendors',
                component: NewVendorComponent
            },
            {
                path: 'listsalesPerson',
                component: SalesPersonListComponent
            },
            {
                path: 'createsalesPerson',
                component: NewSalesPersonComponent
            },
            {
                path: 'listRoles',
                component: RoleListComponent
            },
            {
                path: 'userRegistration',
                component: UserRegistrationComponent
            },
            {
                path: 'createRoles',
                component: CreateRolesComponent
            },
            {
                path: 'listUnitsOfMeasure',
                component: ListUnitOfMeasureComponent
            },
            {
                path: 'createUnitsOfMeasure',
                component: CreateUnitOfMeasureComponent
            },
            {
                path: 'listPaymentTerm',
                component: ListPaymentTermsComponent
            },
            {
                path: 'createPaymentTerm',
                component: CreatePaymentTermsComponent
            },
            {
                path: 'listWarehouse',
                component: ListWarehouseComponent
            },
            {
                path: 'createWarehouse',
                component: NewWarehouseComponent
            },
            {
                path: 'listLocation',
                loadComponent: () =>
                    import('./components/Administration/location/list-location/list-location.component')
                        .then(m => m.ListLocationComponent)
            },
            {
                path: 'createLocation',
                loadComponent: () =>
                    import('./components/Administration/location/create-location/create-location.component')
                        .then(m => m.CreateLocationComponent)
            },
            {
                path: 'createBillofMaterial',
                component: CreateBOMComponent
            },
            {
                path: 'listBillofMaterial',
                component: ListBOMComponent
            },
            {
                path: 'assignRoles',
                component: AssignRoleComponent,
                // canActivate: [MenuGuard],
                // data: { menuName: 'assignRoles' }
            },
            {
                path: 'listassignroles',
                component: AssignRoleListComponent,
                // canActivate: [MenuGuard],
                // data: { menuName: 'listassignroles' }

            },
            {
                path: 'listMenu',
                component: MenuListComponent
            },
            {
                path: 'createMenu',
                component: CreateMenuComponent
            },
            {
                path: 'listQuotes',
                component: ListQuoteComponent
            },
            {
                path: 'createQuotes',
                component: CreateQuoteComponent
            },
            {
                path: 'createOrder',
                component: CreateOrderComponent
            },
            {
                path: 'listOrder',
                component: OrderListComponent
            },
            {
                path: 'CreateInvoice',
                component: CreateInvoiceComponent
            },
            {
                path: 'listInvoice',
                component: InvoiceListComponent
            },
            {
                path: 'dispatchSalesOrder',
                component: DispatchSalesOrderComponent
            },
            {
                path: 'ViewdispatchSalesOrder',
                component: ViewDispatchSalesOrderComponent
            },
            {
                path: 'gst',
                component: GstListComponent
            },
            {
                path: 'userlist',
                component: UserListComponent
            },
            {
                path: 'listPurchaseOrders',
                component: ListPurchaseorderComponent
            },
            {
                path: 'createPurchaseOrder',
                component: CreatePurchaseorderComponent
            },
            {
                path: 'recievePurchaseOrderList',
                component: ReceivePurchaseorderListComponent
            },
            {
                path: 'recievePurchaseOrder',
                component: ReceivePurchaseorderComponent
            },
            {
                path: 'listAccounts',
                component: AccountListComponent
            },
            {
                path: 'createAccounts',
                component: CreateAccountsComponent
            },
            {
                path: 'createpaymentTermList',
                component: CreatePaymentTermsComponent
            },
            {
                path: 'paymentTermList',
                component: ListPaymentTermsComponent
            },
            {
                path: 'createManufacturingOrders',
                component: CreateMOComponent
            },
            {
                path: 'listManufacturingOrders',
                component: ListManufacturingOrdersComponent
            },
            {
                path: 'reportcenter',
                component: ReportListComponent
            },
            {
                path: 'SalesDashboard',
                component: SalesdashboardComponent
            },
            {
                path: 'Return-PO',
                component: CreateReturnPurchaseorderComponent
            },
            {
                path: 'Return-PO-List',
                component: ListReturnPurchaseorderComponent
            },
            {
                path: 'listrfq',
                component: ListRFQComponent
            },
            {
                path: 'createrfq',
                component: CreateRFQComponent
            },
            {
                path: 'storeconsumption',
                component: ListStoreConsumptionsComponent
            },
            {
                path: 'createStoreConsumption',
                component: CreateStoreConsumptionsComponent
            },

            {
                path: 'operations',
                component: OperationComponent,
                canActivate: [MenuGuard],
                data: { menuName: 'operations' }
            },

            {
                path: 'employee-info',
                component: ListEmployeeComponent
            },

            {
                path: 'createEmployees',
                component: EmployeeComponent
            },

            {
                path: 'create-shift',
                component: CreateShiftComponent
            },

            {
                path: 'list-shift',
                component: ListShiftComponent
            },

            {
                path: 'hrmsdashboard',
                component: HRMSHomeDashboardComponent
            },

            {
                path: 'calendar',
                component: CalendarComponent
            },

            {
                path: 'listattendance-tracker',
                loadComponent: () =>
                    import('./components/HRMS/attendance/list-attendance-tracker/attendance-tracker.component')
                        .then(m => m.AttendanceTrackerComponent)
            },


            {
                path: 'listattendance',
                loadComponent: () =>
                    import('./components/HRMS/attendance/list-attendance/attendance.component')
                        .then(m => m.AttendanceComponent)
            },

            {
                path: 'create-leaves',
                loadComponent: () => import('./components/HRMS/leaves/create-leave/create-leave.component')
                    .then(m => m.CreateLeaveComponent)
            },
            {
                path: 'listleaves',
                loadComponent: () => import('./components/HRMS/leaves/list-leave/list-leave.component')
                    .then(m => m.ListLeaveComponent)
            },
            {
                path: 'leave-tracker',
                loadComponent: () => import('./components/HRMS/leaves/leave-tracker/leave-tracker.component')
                    .then(m => m.LeaveTrackerComponent)
            },
            {
                path: 'attendance-approval',
                loadComponent: () =>
                    import('./components/HRMS/attendance/attendance-approval/create-attendance-approval.component')
                        .then(m => m.AttendanceApprovalComponent)
            },
            {
                path: 'location-management',
                loadComponent: () =>
                    import('./components/HRMS/location-management/location-management.component')
                        .then(m => m.LocationManagementComponent),
            },

            {
                path: 'createproject',
                loadComponent: () => import('./components/masters/project-management/create-project/create-project.component')
                    .then(m => m.CreateProjectComponent),
                // canActivate: [MenuGuard],
                // data: { menuName: 'createproject' }
            },
            {
                path: 'listprojects',
                loadComponent: () => import('./components/masters/project-management/list-project/list-project.component')
                    .then(m => m.ListProjectComponent),
                // canActivate: [MenuGuard],
                // data: { menuName: 'listprojects' }
            },

            {
                path: 'receipts',
                loadComponent: () => import('./components/Receipts/receipts-list/receipts-list.component')
                    .then(m => m.ReceiptsListComponent)
            },
            {
                path: 'create-receipt',
                loadComponent: () => import('./components/Receipts/create-receipts/create-receipts.component')
                    .then(m => m.CreateReceiptsComponent)
            },
            {
                path: 'createproductcategory',
                loadComponent: () => import('./components/Administration/Prodcut Category/create-product-category/create-product-category.component')
                    .then(m => m.CreateProductCategoryComponent)
            },
            {
                path: 'listproductcategory',
                loadComponent: () => import('./components/Administration/Prodcut Category/product-category-list/product-category-list.component')
                    .then(m => m.ProductCategoryListComponent)
            },
            {
                path: 'companyinformationlist',
                loadComponent: () => import('./components/Administration/company-information/company-information-list/company-info-list.component')
                    .then(m => m.CompanyInfoListComponent)
            },
            {
                path: 'companyinformation',
                loadComponent: () => import('./components/Administration/company-information/new-company-information/new-company.component')
                    .then(m => m.NewCompanyInfoComponent)
            },
            {
                path: 'systemsettings',
                loadComponent: () => import('./components/Administration/system-settings/system-settings-list/system-settings-list.component')
                    .then(m => m.SystemSettingsListComponent)
            },
            {
                path: 'inventorydashboard',
                loadComponent: () => import('./components/Dashboard/inventory-dashboard/inventory-dashboard.component')
                    .then(m => m.InventoryDashboardComponent)
            },
            {
                path: 'warehousedashboard',
                loadComponent: () => import('./components/Dashboard/warehouse-dashboard/warehouse-dashboard.component')
                    .then(m => m.WarehouseDashboardComponent)
            },
            {
                path: 'listbackorder',
                loadComponent: () => import('./components/Sales/Back Order/back-order-list/back-order-list.component')
                    .then(m => m.BackOrderListComponent)
            },
            {
                path: 'ForceOrderProcess',
                loadComponent: () => import('./components/Sales/Back Order/force-order-process/force-order-process.component')
                    .then(m => m.ForceOrderProcessComponent)
            },
            {
                path: 'bankaccounts',
                loadComponent: () => import('./components/Accounts/Bank/create-bank/create-bank.component')
                    .then(m => m.CreatebankComponent)
            },
            {
                path: 'listbank',
                loadComponent: () => import('./components/Accounts/Bank/bank-list/bank-list.component')
                    .then(m => m.BankListComponent)
            },
            {
                path: 'deliverychallan',
                loadComponent: () => import('./components/inventory/DeliveryChallan/delivery-challan-list/delivery-challan-list.component')
                    .then(m => m.DeliveryChallanListComponent)
            },
            {
                path: 'create-challan',
                loadComponent: () => import('./components/inventory/DeliveryChallan/create-delivery-challan/create-delivery-challan.component')
                    .then(m => m.CreateDeliveryChallanComponent)
            },
            {
                path: 'createPaymentReceipt',
                loadComponent: () => import('./components/Accounts/create-payment-receipts/create-payment-receipts.component')
                    .then(m => m.CreatePaymentReceiptsComponent)
            },
            {
                path: 'viewPaymentReceipt',
                loadComponent: () => import('./components/Accounts/create-payment-receipts/create-payment-receipts.component')
                    .then(m => m.CreatePaymentReceiptsComponent)
            },
            {
                path: 'listPaymentReceipt',
                loadComponent: () => import('./components/Accounts/payment-receipt-list/payment-receipt-list.component')
                    .then(m => m.PaymentReceiptListComponent)
            },
            {
                path: 'createdeal',
                loadComponent: () => import('./components/CRM/Deal/create-deal/create-deal.component')
                    .then(m => m.CreateDealComponent)
            },
            {
                path: 'listdeal',
                loadComponent: () => import('./components/CRM/Deal/list-deal/list-deal.component')
                    .then(m => m.ListDealComponent)
            },
            {
                path: 'listtask',
                loadComponent: () => import('./components/CRM/Task/list-task/list-task.component')
                    .then(m => m.ListTaskComponent)
            },
            {
                path: 'createtask',
                loadComponent: () => import('./components/CRM/Task/create-task/create-task.component')
                    .then(m => m.CreateTaskComponent)
            },
            {
                path: 'listlead',
                loadComponent: () => import('./components/CRM/Lead/list-lead/list-lead.component')
                    .then(m => m.ListLeadComponent)
            },
            {
                path: 'createlead',
                loadComponent: () => import('./components/CRM/Lead/create-lead/create-lead.component')
                    .then(m => m.CreateLeadComponent)
            },
            {
                path: 'inventoryadjustment',
                loadComponent: () => import('./components/inventory/InventoryAdjustments/list-inventory-adjustment/list-inventory-adjustment.component')
                    .then(m => m.ListInventoryAdjustmentComponent)
            },
            {
                path: 'create-inventoryadjustments',
                loadComponent: () => import('./components/inventory/InventoryAdjustments/create-inventory-adjustment/create-inventory-adjustment.component')
                    .then(m => m.CreateInventoryAdjustmentComponent)
            },
            {
                path: 'pos-invoice',
                loadComponent: () => import('./components/point-of-sales/pos-invoice/posinvoice.component')
                    .then(m => m.POSInvoiceComponent)
            },
            {
                path: 'createpos-invoice',
                loadComponent: () => import('./components/point-of-sales/poscreate-invoice/poscreate-invoice.component')
                    .then(m => m.POSCreateInvoiceComponent)
            },
            {
                path: 'pos-order',
                loadComponent: () => import('./components/point-of-sales/pos-order/posorder.component')
                    .then(m => m.POSOrderComponent)
            },
            {
                path: 'invoice-lookup',
                loadComponent: () => import('./components/Lookup/posinvoice-lookup/posinvoice-lookup.component')
                    .then(m => m.POSinvoiceLookupComponent)
            },
            {
                path: 'listservicecalls',
                loadComponent: () => import('./components/service-calls/list-service-calls/list-service-calls.component')
                    .then(m => m.ListServiceCallsComponent)
            },
            {
                path: 'create-service-calls',
                loadComponent: () => import('./components/service-calls/create-service-call/create-service-call.component')
                    .then(m => m.CreateServiceCallComponent)
            },
            {
                path: 'listserviceinvoice',
                loadComponent: () => import('./components/service-calls/list-service-invoice/list-service-invoice.component')
                    .then(m => m.ListServiceInvoiceComponent)
            },
            {
                path: 'createserviceinvoice',
                loadComponent: () => import('./components/service-calls/create-service-invoice/create-service-invoice.component')
                    .then(m => m.CreateServiceInvoiceComponent)
            },
            {
                path: 'createproducttype',
                loadComponent: () => import('./components/Administration/Product-Type/create-product-type/create-product-type.component')
                    .then(m => m.CreateProductTypeComponent)
            },
            {
                path: 'producttype',
                loadComponent: () => import('./components/Administration/Product-Type/product-type-list/product-type-list.component')
                    .then(m => m.ProductTypeListComponent)
            },
            {
                path: 'createproductgroup',
                loadComponent: () => import('./components/Administration/Prodcut Category/create-product-group/create-product-group.component')
                    .then(m => m.CreateProductGroupComponent)
            },
            {
                path: 'listproductgroup',
                loadComponent: () => import('./components/Administration/Prodcut Category/product-group-list/product-group-list.component')
                    .then(m => m.ProductGroupListComponent)
            },
            {
                path: 'createproductsubcategory',
                loadComponent: () => import('./components/Administration/Prodcut Category/create-product-sub-category-component/create-product-sub-category-component.component')
                    .then(m => m.CreateProductSubCategoryComponentComponent)
            },
            {
                path: 'listproductsubcategory',
                loadComponent: () => import('./components/Administration/Prodcut Category/product-sub-category-list/product-sub-category-list.component')
                    .then(m => m.ProductSubCategoryListComponent)
            },
            {
                path: 'createproductrequisition',
                loadComponent: () => import('./components/Purchase/productrequisition/create-product-requisition/create-product-requisition.component')
                    .then(m => m.CreateProductRequisitionComponent)
            },
            {
                path: 'listproductrequisition',
                loadComponent: () => import('./components/Purchase/productrequisition/list-product-requisition/list-product-requisition.component')
                    .then(m => m.ListProductRequisitionComponent)
            },
            {
                path: 'crmcontactlist',
                loadComponent: () => import('./components/CRM/Contact/list-crmcontact-component/list-crmcontact-component.component')
                    .then(m => m.ListCRMContactComponentComponent)
            },
            {
                path: 'createcrmcontact',
                loadComponent: () => import('./components/CRM/Contact/crmcontact-component/crmcontact-component.component')
                    .then(m => m.CRMContactComponentComponent)
            },
            {
                path: 'listprojecttask',
                loadComponent: () => import('./components/masters/project-task-management/list-project-task/list-project-task.component')
                    .then(m => m.ListProjectTaskComponent)
            },
            {
                path: 'createprojecttask',
                loadComponent: () => import('./components/masters/project-task-management/create-project-task/create-project-task.component')
                    .then(m => m.CreateProjectTaskComponent)
            },

            {
                path: 'listprojectphase',
                loadComponent: () => import('./components/masters/project-phase-management/list-project-phase/list-project-phase.component')
                    .then(m => m.ListProjectPhaseComponent)
            },
            {
                path: 'createprojectphase',
                loadComponent: () => import('./components/masters/project-phase-management/create-project-phase/create-project-phase.component')
                    .then(m => m.CreateProjectPhaseComponent)
            },
            {
                path: 'projecttimesheet',
                loadComponent: () => import('./components/masters/time-sheets/list-timesheet/list-timesheet.component')
                    .then(m => m.ListTimesheetComponent)
            },
            {
                path: 'createtimesheet',
                loadComponent: () => import('./components/masters/time-sheets/create-timesheet/create-timesheet.component')
                    .then(m => m.CreateTimesheetComponent)
            },
            {
                path: 'projectDashboard',
                loadComponent: () => import('./components/masters/project-dashboard/project-dashboard.component')
                    .then(m => m.ProjectDashboardComponent)
            },
            {
                path: 'listvendorbill',
                loadComponent: () => import('./components/masters/vendor-list/listvendorbill.component')
                    .then(m => m.ListVendorBillComponent)
            },
            {
                path: 'createvendorbill',
                loadComponent: () => import('./components/masters/vendor-bill/vendor-bill.component')
                    .then(m => m.VendorBillComponent)
            },
            {
                path: 'timesheets',
                loadComponent: () => import('./components/HRMS/list-timesheet/list-timesheet.component')
                    .then(m => m.ListTimesheetComponent)
            },
            {
                path: 'createhrmstimesheet',
                loadComponent: () => import('./components/HRMS/create-timesheet/create-timesheet.component')
                    .then(m => m.CreateTimesheetComponent)
            },
            {
                path: 'listvendorpayment',
                loadComponent: () => import('./components/masters/vendor-payment-list/vendor-payment-list.component')
                    .then(m => m.VendorPaymentListComponent)
            },
            {
                path: 'createvendorpayment',
                loadComponent: () => import('./components/masters/vendor-payment/vendor-payment.component')
                    .then(m => m.VendorPaymentComponent)
            },

            {
                path: 'tdstaxes',
                loadComponent: () => import('./components/Administration/TDS/taxes-list/taxes-list.component')
                    .then(m => m.TaxesListComponent)
            },
            {
                path: 'create-tdstaxes',
                loadComponent: () => import('./components/Administration/TDS/tds-taxes/tds-taxes.component')
                    .then(m => m.TdsTaxesComponent)
            },

            {
                path: 'manualjournals',
                loadComponent: () => import('./components/Accounts/ManualJournals/manual-journals/manual-journals.component')
                    .then(m => m.ManualJournalsComponent)
            },

            {
                path: 'manualjournalslist',
                loadComponent: () => import('./components/Accounts/ManualJournals/manual-journal-list/manual-journal-list.component')
                    .then(m => m.ManualJournalListComponent)
            },
            {
                path: 'listVoucher',
                loadComponent: () => import('./components/Voucher/list-voucher/list-voucher.component')
                    .then(m => m.ListVoucherComponent)
            },
            {
                path: 'createVoucher',
                loadComponent: () => import('./components/Voucher/create-voucher/create-voucher.component')
                    .then(m => m.CreateVoucherComponent)
            },
            {
                path: 'createProposal',
                loadComponent: () => import('./components/Sales/Proposal/create-proposal/create-proposal.component'
                ).then((m) => m.CreateProposalComponent),
            },
            {
                path: 'listproposal',
                loadComponent: () => import('./components/Sales/Proposal/list-proposal/list-proposal.component')
                    .then(m => m.ListProposalComponent)
            },
            {
                path: 'transactionseries',
                loadComponent: () => import('./components/Administration/transaction-series/transaction-series.component')
                    .then(m => m.TransactionSeriesComponent)
            },
            {
                path: 'listProjectBOM',
                loadComponent: () => import('./components/masters/project-BOM-management/list-project-bom/list-project-bom.component')
                    .then(m => m.ListProjectBOMComponent)
            },
            {
                path: 'createprojectbom',
                loadComponent: () => import('./components/masters/project-BOM-management/create-project-bom/create-project-bom.component')
                    .then(m => m.CreateProjectBomComponent)
            },
            {
                path: 'materialrequests',
                loadComponent: () => import('./components/Purchase/MaterialRequest/list-materialrequests/list-materialrequests.component')
                    .then(m => m.ListMaterialrequestsComponent)
            },
            {
                path: 'creatematerialrequests',
                loadComponent: () => import('./components/Purchase/MaterialRequest/create-materialrequests/create-materialrequests.component')
                    .then(m => m.CreateMaterialrequestsComponent)
            },
            {
                path: 'modulesettings',
                loadComponent: () => import('./components/masters/approval-component/approval-component.component')
                    .then(m => m.ApprovalComponentComponent)
            },
            {
                path: 'reminders',
                loadComponent: () => import('./components/Administration/Reminders/create-reminders/create-reminders.component')
                    .then(m => m.CreateRemindersComponent)
            },
            {
                path: 'salesreturn',
                loadComponent: () => import('./components/Sales/Return Sales/list-salesreturn/list-salesreturn.component')
                    .then(m => m.ListReturnSalesComponent)
            },
            {
                path: 'createsalesreturn',
                loadComponent: () => import('./components/Sales/Return Sales/create-returnsales/create-returnsales.component')
                    .then(m => m.CreateReturnSalesComponent)
            },
            {
                path: 'issuematerials',
                loadComponent: () => import('./components/inventory/issue-materials/issue-materials-list/issue-materials.component')
                    .then(m => m.IssueMaterialsComponent)
            },
            {
                path: 'createissuematerials',
                loadComponent: () => import('./components/inventory/issue-materials/create-issue-materials/create-issue-materials.component')
                    .then(m => m.CreateIssueMaterialsComponent)
            },
            {
                path: 'ewaybills',
                loadComponent: () => import('./components/Sales/eway-bill/list-ewaybill/list-ewaybill.component')
                    .then(m => m.ListEwaybillComponent)
            },
            {
                path: 'createEwaybill',
                loadComponent: () => import('./components/Sales/eway-bill/create-ewaybill/create-ewaybill.component'
                ).then((m) => m.CreateEwaybillComponent),
            },

            {
                path: 'onboard',

                loadComponent: () => import('./components/HRMS/onboard/onboarding-list/onboarding-list.component'
                ).then((m) => m.OnboardingListComponent),
            },
            {
                path: 'add-employee',
                loadComponent: () => import('./components/HRMS/onboard/add-employee/add-employee.component').
                    then((m) => m.AddEmployeeComponent),
            },
            {
                path: 'onboard',
                loadComponent: () => import('./components/HRMS/onboard/onboarding-list/onboarding-list.component')
                    .then((m) => m.OnboardingListComponent),
            },
            {
                path: 'add-employee',
                loadComponent: () => import('./components/HRMS/onboard/add-employee/add-employee.component')
                    .then((m) => m.AddEmployeeComponent),
            },
            {
                path: 'add-employee/:id',
                loadComponent: () => import('./components/HRMS/onboard/add-employee/add-employee.component')
                    .then((m) => m.AddEmployeeComponent),
            },
            {
                path: 'offboarding/list',
                loadComponent: () =>
                    import('./components/HRMS/offboarding/resignation-list/resignation-list.component')
                        .then(m => m.ResignationListComponent)
            },
            {
                path: 'offboarding/create',
                loadComponent: () =>
                    import('./components/HRMS/offboarding/create-offboarding/create-offboarding.component')
                        .then(m => m.CreateOffboardingComponent)
            },
              {
                path: 'offboarding-home',
                loadComponent: () =>
                    import('./components/HRMS/offboarding/offboarding-home/offboarding-home.component')
                        .then(m => m.OffboardingHomeComponent)
            },
            {
                path: 'offboarding',
                redirectTo: 'offboarding-home',
                pathMatch: 'full'
            },

            {
                path: 'expense',
                loadComponent: () =>
                    import('./components/HRMS/expense/list-expense/list-expense.component')
                        .then(m => m.ListExpenseComponent)
            },

            {
                path: 'expense/create-expense',
                loadComponent: () =>
                    import('./components/HRMS/expense/create-expense/create-expense.component')
                        .then(m => m.ExpenseComponent)
            },
            {
                path: 'expense/edit-expense',
                loadComponent: () =>
                    import('./components/HRMS/expense/create-expense/create-expense.component')
                        .then(m => m.ExpenseComponent)
            },

            {
                path: 'expense',
                redirectTo: 'expense',
                pathMatch: 'full'
            },

            {
                path: 'emp-engagement',
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import('./components/HRMS/emp-engagement/alllist/alllist.component')
                                .then((m) => m.AlllistComponent),
                    },
                    {
                        path: 'new',
                        loadComponent: () =>
                            import('./components/HRMS/emp-engagement/allfeed/allfeed.component')
                                .then((m) => m.AllfeedComponent),
                    }
                ]
            },
            {
                path: 'einvoicing',
                loadComponent: () => import('./components/Administration/einvoicing-settings/einvoicing-settings.component')
                    .then(m => m.EinvoicingSettingsComponent)
            },

            //files path 
            //                   {
            //     path: 'files',
            //     loadComponent: () =>
            //         import('./components/HRMS/files/fileslist/fileslist.component')
            //             .then(m => m.FileslistComponent)
            // },
            // {
            //     path: 'filestab',
            //     loadComponent: () =>
            //         import('./components/HRMS/files/filestab/filestab.component')
            //             .then(m => m.FilestabComponent)
            // },




            {
                path: 'listfinancialyear',
                loadComponent: () => import('./components/Accounts/financialYear/list-financial-year/list-financial-year.component')
                    .then(m => m.ListFinancialYearComponent)
            },

                // files path 
            {
                path: 'files',
                loadComponent: () =>
                    import('./components/HRMS/files/fileslist/fileslist.component')
                        .then(m => m.FileslistComponent)
            },
            {
                path: 'filestab',
                loadComponent: () =>
                    import('./components/HRMS/files/filestab/filestab.component')
                        .then(m => m.FilestabComponent)
            },
            {
                path: 'hrfile',
                loadComponent: () =>
                    import('./components/HRMS/files/hrfile/hrfile.component')
                        .then(m => m.HrfileComponent)
            },

             {
    path: 'assets',
    loadComponent: () => import('./components/HRMS/assets/dashboard/dashboard.component')
                        .then(m => m.DashboardComponent)
             },
        ]

    },


    //genral card path

              

    // {
    //     path: '**',
    //     redirectTo: 'home/dashboard'
    // }
];
